import React, { Component } from 'react'
import DraggableCodeList from './DraggableCodeList'

class CodeBlocksContainer extends Component {
  state = {}

  componentDidMount = () => {
    var bounds = this.container_.getBoundingClientRect()
    this.setState({ width: bounds.width })
  }

  codesFilter = code => {
    const { codeFilterString } = this.props
    if (!codeFilterString) return true
    return code.toLowerCase().indexOf(codeFilterString.toLowerCase()) !== -1
  }

  render = () => {
    return (
      <div ref={el => (this.container_ = el)} className="CodeBlocksContainer">
        {this.renderCodes()}
      </div>
    )
  }

  renderCodes = () => {
    var { codes, onCodeGrab, totalCodes, onCodeClick } = this.props
    const { width } = this.state

    if (!width) return null

    var filteredCodes = codes.filter(this.codesFilter)
    filteredCodes = filteredCodes.slice(0, 25)
    return [
      <DraggableCodeList
        width={width}
        codes={filteredCodes}
        onCodeGrab={onCodeGrab}
        onCodeClick={onCodeClick}
      />,
      totalCodes !== undefined ? (
        <div className="view-summary">
          <span>showing </span>
          <strong>{filteredCodes.length}</strong>
          <span> of </span>
          <strong>{totalCodes}</strong>
        </div>
      ) : null,
    ]
  }
}

export default CodeBlocksContainer
